import {request} from "../../Base/HTTP";

export async function getPermissions(data) {
    return await request('/api/permissions', data);
}
